<!--
 * @created on 2018/10/29
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <transition name="fade">
        <div class="text-input" v-show="open">
            <header class="input-header">
                <div class="btn back-btn" @click="cancelInput">
                    <svg-icon icon-class="vertical-arrow" class-name="icon"></svg-icon>
                </div>
                <div class="title">{{ title }}</div>
                <div :class="['btn','submit-btn',{'disable':overflow || !canSubmit}]" @click="finishInput">
                    <div class="btn-text">{{ submitText }}</div>
                </div>
            </header>
            <textarea class="input-content" :title="title" :placeholder="placeholder" v-model="textValue"
                      @keyup="handleKeyup" ref="container"></textarea>
        </div>
    </transition>

</template>

<style scoped lang="scss">
@import "../../style/config";
@import "../../style/function";

.text-input {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
}

.input-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    border-bottom: px2rem(1) solid #e5e5e5;
    background: #fff;
    height: px2rem(88);
    z-index: 3;

    .title {
        flex: 1;
        font-size: px2rem(36);
        color: #2e2e2e;
    }

    .icon {
        width: px2rem(34);
        height: px2rem(34);
    }

    .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: px2rem(90);
        height: 100%;
        color: $btnColor;

        &.disable {
            color: #e5e5e5;
        }
    }

    .btn-text {
        font-size: px2rem(32);
    }
}

.input-content {
    margin: 0;
    width: 100%;
    height: 100%;
    flex: 1;
    padding: px2rem(30+88) px2rem(30) px2rem(30);
    resize: none;
    outline: none;
    box-sizing: border-box;
    line-height: 1.5;
    font-size: px2rem(32);
    color: #333;
    border: none;
    background: #fff;

    &::-webkit-scrollbar {
        display: none;
    }
}
</style>

<script>
export default {
    name: "TextInput",
    props: {
        open: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "点击输入文本"
        },

        value: {
            type: String
        },

        title: {
            type: String,
            default: "回复"
        },

        submitText: {
            type: String,
            default: "完成"
        },

        focus: {
            type: Boolean,
            default: true
        },

        limit: {
            type: Number,
            default: 9999
        }
    },
    data() {
        return {
            textValue: null,
            overflow: false
        };
    },
    watch: {
        open(n) {
            if (n) {
                this.disablePageScroll();

                // 自动聚焦
                if (this.focus) {
                    setTimeout(() => {
                        // TODO ios下面不能自动聚集，取消自动聚焦操作
                        if (this.$env.isIOS) {
                            console.warn(
                                "textInput[autoFocus]:IOS device does not support this feature"
                            );
                        } else {
                            this.$refs.container.focus();
                        }
                    }, 100);
                }
            } else {
                this.enablePageScroll();
            }
        },

        value(n) {
            if (n !== this.textValue) {
                this.textValue = decodeURIComponent(n);
            }
        }
    },

    computed: {
        canSubmit() {
            return !!this.textValue;
        }
    },

    beforeDestroy() {
        this.enablePageScroll();
    },

    methods: {
        // 禁用页面滚动
        disablePageScroll() {
            document.body.style += "height:100%;overflow:hidden";
        },

        // 启用页面滚动
        enablePageScroll() {
            document.body.style.height = "";
            document.body.style.overflow = "";
        },

        handleKeyup() {
            if (this.handleKeyup.time) clearTimeout(this.handleKeyup.time);

            this.handleKeyup.time = setTimeout(() => {
                if (this.textValue && this.textValue.length > this.limit) {
                    this.overflow = true;

                    this.$toast.open({ msg: "字数超过限制！" });
                } else {
                    this.overflow = false;
                }
            }, 300);
        },

        // 完成输入
        finishInput() {
            if (
                this.overflow ||
                (this.textValue && this.textValue.length > this.limit)
            ) {
                // 由于直接复制粘贴会导致 onKeyup 时间不触发，这里重新触发一次
                this.overflow = true;

                this.$toast.open({ msg: "字数超过限制！" });
                return;
            }

            if (!this.canSubmit) {
                this.$toast.open({ msg: "请输入有效内容！" });
                return;
            }

            this.$emit("finish", {
                type: "textInput.finish",
                value: encodeURIComponent(this.textValue),
                len: this.textValue ? this.textValue.length : 0
            });
        },

        // 结束输入
        cancelInput() {
            this.$emit("cancel", {
                type: "textInput.cancel",
                value: encodeURIComponent(this.textValue),
                len: this.textValue ? this.textValue.length : 0
            });
        }
    }
};
</script>
